import { useEffect, useRef, useState } from "react";
import { LiaSearchPlusSolid, LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import { Press } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import Model from "../../common/Model";
import FormFields from "../../common/FormFields";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import { RegistryHeader, Button as SharedButton } from "../../common/Shared";
import { formatDate } from "../../utlis/formateDate";

const PressMaster = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    pressId: "",
    mfgName: "",
    purchaseDate: today,
    totalForce: "",

    workingPressure: "",
    mainCylinderId: "",
    sideCylinderId: "",
    mainRamStroke: "",

    billetOd: "",
    maxBilletLength: "",
    containerSleeveOd: "",
    containerSleeveId: "",
    containerSleeveLength: "",

    beemForwarding: "",
    minExtrusionSpeed: "",
    maxExtrusionSpeed: "",

    noOfPumps: "",
    pumpModel: "",
    noOfMotors: "",
    motorModel: "",
    capacity: "",
    motorSpeed: "",
    voltage: "",
    isServoMotor: false,

    dieSetOd: "",
    dieSetDepth: "",
    exitHoleWidth: "",
    exitHoleHeight: "",
    heatingPower: "",
    setupTemp: "",

    hydroulicOilCap: "",
    oilViscosity: "",

    createdBy: userId,
  });
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPressData, setIsPressData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 50;
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);
  const tableScrollRef = useRef(null);

  const fetchPressData = async () => {
    if (isFetchingRef.current) return;
    setLoading(true);
    try {
      const res = await Press.getAllPress(currentPage, pageSize);
      const newItems = res.data;

      if (currentPage === 1) {
        setIsPressData(newItems);
      } else {
        setIsPressData((prev) => [...prev, ...newItems]);
      }

      if (newItems.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    } catch (error) {
      notify("Error fetching location data", "error");
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || !hasMore || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;
        setCurrentPage((p) => p + 1);
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    fetchPressData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isPressData);
    } else {
      const filtered = isPressData.filter((d) =>
        d.mfgName?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isPressData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      pressId: 0,
      mfgName: "",
      purchaseDate: today,
      totalForce: "",
      workingPressure: "",
      mainCylinderId: "",
      sideCylinderId: "",
      mainRamStroke: "",
      billetOd: "",
      maxBilletLength: "",
      containerSleeveOd: "",
      containerSleeveId: "",
      containerSleeveLength: "",
      beemForwarding: "",
      minExtrusionSpeed: "",
      maxExtrusionSpeed: "",
      noOfPumps: "",
      pumpModel: "",
      noOfMotors: "",
      motorModel: "",
      capacity: "",
      motorSpeed: "",
      voltage: "",
      isServoMotor: false,
      dieSetOd: "",
      dieSetDepth: "",
      exitHoleWidth: "",
      exitHoleHeight: "",
      heatingPower: "",
      setupTemp: "",
      hydroulicOilCap: "",
      oilViscosity: "",
      createdBy: userId,
    });
  };

  const handleAdd = () => {
    setIsModelOpen(true);
    setIsEditing(false);
    resetForm();
  };

  const handleEdit = async (id) => {
    try {
      const res = await Press.getById(id);
      const data = res?.data;
      if (!data) return;

      if (data) {
        setFormData({
          pressId: data.pressId,
          mfgName: data.mfgName,
          purchaseDate: data.purchaseDate?.substring(0, 10) || "",
          totalForce: data.totalForce ?? "",
          workingPressure: data.workingPressure ?? "",
          mainCylinderId: data.mainCylinderId ?? "",
          sideCylinderId: data.sideCylinderId ?? "",
          mainRamStroke: data.mainRamStroke ?? "",
          billetOd: data.billetOd ?? "",
          maxBilletLength: data.maxBilletLength ?? "",
          containerSleeveOd: data.containerSleeveOd ?? "",
          containerSleeveId: data.containerSleeveId ?? "",
          containerSleeveLength: data.containerSleeveLength ?? "",
          beemForwarding: data.beemForwarding ?? "",
          minExtrusionSpeed: data.minExtrusionSpeed ?? "",
          maxExtrusionSpeed: data.maxExtrusionSpeed ?? "",
          noOfPumps: data.noOfPumps ?? "",
          pumpModel: data.pumpModel ?? "",
          noOfMotors: data.noOfMotors ?? "",
          motorModel: data.motorModel ?? "",
          capacity: data.capacity ?? "",
          motorSpeed: data.motorSpeed ?? "",
          voltage: data.voltage ?? "",
          isServoMotor: data.isServoMotor ?? false,
          dieSetOd: data.dieSetOd ?? "",
          dieSetDepth: data.dieSetDepth ?? "",
          exitHoleWidth: data.exitHoleWidth ?? "",
          exitHoleHeight: data.exitHoleHeight ?? "",
          heatingPower: data.heatingPower ?? "",
          setupTemp: data.setupTemp ?? "",
          hydroulicOilCap: data.hydroulicOilCap ?? "",
          oilViscosity: data.oilViscosity ?? "",
          Modify_By: userId,
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (error) {
      notify("Failed to fetch location details", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await Press.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchPressData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSubmit = async ({ resetOnly = false }) => {
    setIsSaving(true);
    try {
      await Press.saveOrUpdate(formData);
      notify(
        isEditing ? "Updated successfully" : "Added successfully",
        "success",
      );
      fetchPressData();
      resetForm();
      setIsEditing(false);
      if (!resetOnly) {
        setIsModelOpen(false);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const fields = [
    { type: "section", label: "General Details" },

    { name: "pressId", label: "Press ID/Number", disabled: true },
    { name: "mfgName", label: "Manufacturer Name", type: "text" },
    { name: "purchaseDate", label: "Date of Purchase", type: "date" },
    { name: "totalForce", label: "Total Force", type: "number", unit: "MT" },

    { type: "section", label: "Hydraulic Cylinder Details" },

    {
      name: "workingPressure",
      label: "Working Pressure",
      type: "number",
      unit: "KG/CM²",
    },
    {
      name: "mainCylinderId",
      label: "Main Cylinder ID",
      type: "number",
      unit: "MM",
    },
    {
      name: "sideCylinderId",
      label: "Side Cylinder ID",
      type: "number",
      unit: "MM",
    },
    {
      name: "mainRamStroke",
      label: "Main Ram Stroke",
      type: "number",
      unit: "MM",
    },

    { type: "section", label: "Billet/Container Details" },

    { name: "billetOd", label: "Billet OD", type: "number", unit: "MM" },
    {
      name: "maxBilletLength",
      label: "Max Billet Length",
      type: "number",
      unit: "MM",
    },
    {
      name: "containerSleeveOd",
      label: "Container Sleeve OD",
      type: "number",
      unit: "MM",
    },
    {
      name: "containerSleeveId",
      label: "Container Sleeve ID",
      type: "number",
      unit: "MM",
    },
    {
      name: "containerSleeveLength",
      label: "Container Sleeve Length",
      type: "number",
      unit: "MM",
    },

    { type: "section", label: "Extrusion Speeds" },

    {
      name: "beemForwarding",
      label: "Beam Forwarding",
      type: "number",
      unit: "MM/S",
    },
    {
      name: "minExtrusionSpeed",
      label: "Min Extrusion Speed",
      type: "number",
      unit: "MM/S",
    },
    {
      name: "maxExtrusionSpeed",
      label: "Max Extrusion Speed",
      type: "number",
      unit: "MM/S",
    },

    { type: "section", label: "Pump/Motor Details" },

    { name: "noOfPumps", label: "Number of Pumps", type: "number" },
    { name: "pumpModel", label: "Pump Model", type: "text" },
    { name: "noOfMotors", label: "Number of Motors", type: "number" },
    { name: "motorModel", label: "Motor Model", type: "text" },
    { name: "capacity", label: "Capacity", type: "number", unit: "KW" },
    { name: "motorSpeed", label: "Speed", type: "number", unit: "RPM" },
    { name: "voltage", label: "voltage", type: "number", unit: "V" },
    { name: "isServoMotor", label: "Servo Motor System", type: "checkbox" },

    { type: "section", label: "Tooling Details" },

    { name: "dieSetOd", label: "Die Set OD", type: "number", unit: "MM" },
    { name: "dieSetDepth", label: "Die Set Depth", type: "number", unit: "MM" },
    {
      name: "exitHoleWidth",
      label: "Exit Hole Width",
      type: "number",
      unit: "MM",
    },
    {
      name: "exitHoleHeight",
      label: "Exit Hole Height",
      type: "number",
      unit: "MM",
    },
    {
      name: "heatingPower",
      label: "Heating Power",
      type: "number",
      unit: "KW",
    },
    { name: "setupTemp", label: "Setup Temp", type: "number", unit: "°C" },

    { type: "section", label: "Maintenance Details" },

    {
      name: "hydroulicOilCap",
      label: "Hydraulic Oil Cap.",
      type: "number",
      unit: "LITERS",
    },
    { name: "oilViscosity", label: "Oil Viscosity", type: "text" },
  ];

  return (
    <>
    <div className="flex flex-col h-full bg-white font-plus">
      <RegistryHeader title="Press Master">
          <div className="relative w-full sm:w-80 group">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-[#3F80F7]">
              <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
            </div>
            <input
              type="text"
              placeholder="Search..."
              className="block w-full pl-12 pr-10 py-3 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-[#3F80F7] focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
              >
                <MdClose size={18} />
              </button>
            )}
          </div>

          <SharedButton
            onClick={handleAdd}
            icon={HiOutlinePlus}
          >
            Add Press
          </SharedButton>
        </RegistryHeader>

        <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col">
          <div
            ref={tableScrollRef}
            className="relative overflow-auto border border-gray-200 bg-white flex-1"
          >
            {loading && <Loader centered />}
            <div className="min-w-max">
            <Table
              columns={[
                { key: "pressId", label: "Press No" },
                { key: "mfgName", label: "Mfg" },
                {
                  key: "purchaseDate",
                  label: "Pur. Date",
                  render: (value) => formatDate(value),
                },
                { key: "totalForce", label: "Total Force" },
                { key: "workingPressure", label: "Pressure" },
                { key: "mainCylinderId", label: "Main ID" },
                { key: "sideCylinderId", label: "Side ID" },
                { key: "mainRamStroke", label: "Stroke" },
                { key: "billetOd", label: "Billet OD" },
                { key: "maxBilletLength", label: "Billet Length" },
                { key: "containerSleeveOd", label: "Sleeve OD" },
                { key: "containerSleeveId", label: "Sleeve ID" },
                { key: "containerSleeveLength", label: "Sleeve Length" },
                { key: "beemForwarding", label: "Beam Forwarding" },
                { key: "minExtrusionSpeed", label: "Ext Speed Min" },
                { key: "maxExtrusionSpeed", label: "Ext Speed Max" },
                { key: "noOfPumps", label: "No. of Pumps" },
                { key: "pumpModel", label: "Pump Model" },
                { key: "noOfMotors", label: "No. of Motors" },
                { key: "motorModel", label: "Motor Model" },
                { key: "capacity", label: "Motor Capacity" },
                { key: "motorSpeed", label: "Motor Speed" },
                { key: "voltage", label: "Voltage" },
                { key: "isServoMotor", label: "Servo Motor" },
                { key: "dieSetOd", label: "Die Set OD" },
                { key: "dieSetDepth", label: "Die Set Depth" },
                { key: "exitHoleWidth", label: "Exit Width" },
                { key: "exitHoleHeight", label: "Exit Height" },
              ]}
              data={filteredData}
              onEdit={(row) => handleEdit(row.pressId)}
              onDelete={(row) => handleDelete(row.pressId)}
              tableClassName="text-[12px] font-bold"
            />
          </div>
        </div>
      </div>
    </div>

      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Press" : "Add Press"}
      >
        <FormFields
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: false });
          }}
          onSubmitAndAddNew={(e) => {
            e.preventDefault();
            handleSubmit({ resetOnly: true });
          }}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={fields}
          isEditing={isEditing}
          onClear={() => setIsModelOpen(false)}
          isSaving={isSaving}
        />
      </Model>

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default PressMaster;
